var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("questionnaire-form", {
    attrs: { questionnaire: _vm.questionnaire },
    on: { change: _vm.onChange, stateChange: _vm.onStateChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }